// Session-scoped token storage — clears when the user closes the last tab/browser.
// Reading also falls back to legacy localStorage so users mid-transition don't get bounced.
const KEY = "cera_token";

export const tokenStore = {
  get() {
    try {
      const v = sessionStorage.getItem(KEY);
      if (v) return v;
      // Legacy fallback + migrate: if a token from a previous localStorage-era session
      // is still around we forcibly clear it (satisfies iter-42 "must re-login on browser
      // reopen" behavior). No implicit migration.
      const legacy = localStorage.getItem(KEY);
      if (legacy) localStorage.removeItem(KEY);
      return null;
    } catch { return null; }
  },
  set(v) {
    try { sessionStorage.setItem(KEY, v); } catch { /* noop */ }
  },
  clear() {
    try { sessionStorage.removeItem(KEY); } catch { /* noop */ }
    try { localStorage.removeItem(KEY); } catch { /* noop */ }
  },
};
